<script setup lang="ts">
// the single place that decides whether a person name is a link -- use this
// everywhere a person name is rendered so linking stays consistent site-wide.
// text size is inherited from the context it is rendered in.
const props = defineProps<{ name: string; slug?: string | null }>()

// only people whose page has content or relations are clickable
const linkablePeopleSlugs = useLinkablePeopleSlugs()
const isLinkable = computed(() => !!props.slug && linkablePeopleSlugs.value.has(props.slug))

// from anywhere but the people list the person opens as an overlay on the
// current page rather than navigating (see `composables/use-person-overlay.ts`)
const { opensInOverlay, routeObject, href, onClick } = usePersonLink(() => props.slug)
</script>

<template>
  <a
    v-if="isLinkable && opensInOverlay"
    :href="href"
    class="text-hover-accent focus:outline-none focus-visible:outline-none"
    @click="onClick"
  >{{ name }}</a>
  <site-link
    v-else-if="isLinkable"
    :route-object="routeObject"
    class="text-hover-accent"
  >{{ name }}</site-link>
  <span v-else>{{ name }}</span>
</template>
